import React, {useEffect, useRef, useState} from 'react';

import {Line} from "../global/Line";
import {GifVideo} from "../global/GifVideo";
import Typed from "typed.js";
import {Numbers} from "../global/Numbers";

export const Intro = ({data, stats}) => {
  const fields = data || {};

  const labelRef = useRef(null);

  const [line, setLine] = useState(null);
  const textBlock = useRef(null);

  const typedOptions = {
    showCursor:false,
    typeSpeed: 30,
  };
  let typed = [
    {
      text : data.titlePart1,
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart2,
      suptext : useRef(null),
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart3,
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart4,
      ref : useRef(null),
      typed : useRef(null)
    },
    {
      text : data.titlePart5,
      ref : useRef(null),
      suptext : useRef(null),
      typed : useRef(null)
    },
  ];
  const LineX = () =>{
    return <Line start={typed[4].suptext} end={labelRef} color={"#DEFF1A"} animateDrawing={0.4} />;
  };
  //Typed
  useEffect(() => {
    let nextWordDelay = 0;
    typed.forEach( (item, index) => {
      if(index !== 0){
        nextWordDelay += typed[index - 1].text.length * typedOptions.typeSpeed;
      }

      item.typed.current = new Typed(item.ref.current, {
        ...typedOptions,
        startDelay : nextWordDelay,
        strings: [
          item.text
        ],
        preStringTyped: (arrayPos, self) => {
          self.el.classList.remove('opacity-0')
          if (item.suptext){
            item.suptext.current.classList.remove('opacity-0')
          }
        },
        onComplete: (self) => {
          if(index === typed.length - 1){
            setLine(<LineX />);

            textBlock.current.classList.remove('opacity-0')
            document.querySelector('.zg-use-intro-img')?.classList.remove('opacity-0')
          }
        },
      });
    })
    return () => {
      // Make sure to destroy Typed instance during cleanup
      // to prevent memory leaks
      typed.forEach( (item, index) => {
        item.typed.current.destroy();
      });
    }
  }, []);




  return (
    <section className="pt-14-rem pb-md-11 pb-11 intro">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-8 col-lg-10 col-xl-8">
            <h1 className="mb-6 mb-md-11 d-inline-flex flex-wrap align-items-start h2 position-relative">
              <span className="zg-text-bg bg-green mb-1 mb-md-2 me-1 me-md-2 opacity-0" ref={typed[0].ref}></span>
              <span className="zg-text-bg bg-white mb-1 me-1 me-md-2 mb-md-2 opacity-0" ref={typed[1].ref}></span>
              <span className="zg-label zg-label--intro bg-white me-1 me-md-2 opacity-0" ref={typed[1].suptext}>{fields.suptext1}</span>
              <span className="zg-text-bg bg-white me-1 me-md-2 mb-1 mb-md-2 opacity-0" ref={typed[2].ref}></span>
              <span className="zg-text-bg bg-yellow me-1 me-md-2 mb-1 mb-md-2 opacity-0" ref={typed[3].ref}></span>
              <span className="zg-text-bg bg-yellow me-1 me-md-2 mb-1 mb-md-2 opacity-0" ref={typed[4].ref}></span>
              <span className="zg-label zg-label--intro bg-yellow opacity-0" ref={typed[4].suptext}>{fields.suptext2}</span>
            </h1>
          </div>
          <div className="col d-none d-md-block">
            <GifVideo fileName="RSK_Defi_Animated_Green_Black_compressed" classes="zg-use-intro-img opacity-0 transition-opacity"/>
          </div>
        </div>
        <div className="opacity-0 transition-opacity" ref={textBlock}>
          <div className="row align-items-lg-start align-items-md-center mb-lg-11">
            <div className="col-lg-3 col-md-6 col-10 offset-lg-7 offset-md-5 offset-1 align-self-md-end mt-6 mt-md-0">
              <div className='d-flex align-items-start'>
                <span className="zg-label text-black bg-yellow me-2" ref={labelRef}>{fields.number}</span>
                <p className="subtitle-md mb-0">{fields.text}</p>
              </div>
            </div>
            <div className="col-9 offset-1 d-block d-md-none mt-3">
              <GifVideo fileName="RSK_Defi_Animated_Green_Black_compressed" classes="mt-lg-0 mt-md-10 zg-use-intro-img"/>
            </div>
          </div>
          <Numbers stats={stats} color={'green'}/>

        </div>

        {line}
      </div>
    </section>
  )
}
